import { useParams } from "react-router";
import constant from "../../../../../constants/constant";
import { Region_List } from "../../../../../constants/region";
import { isValidNumberInput } from "../../../../../constants/utils";
import atoms from "../../../../atoms";
import { TerritoryListProps } from "../interface";
import { AddStoreDetailProps } from "./interface";

const { Input, DatePicker, Select, IntlPhoneField } = atoms;

export const AddStoreDetail = ({
    setStoreDetails,
    storeDetails,
    errors,
    _handleSearchStoreLocation,
    handleChangeRegion,
    handleStateGovernorateChange,
    cities,
    territoryList,
}: AddStoreDetailProps) => {
    const params = useParams()

    return (
        <div className="row">
            <div className="col-4 mt-25">
                <Select
                    label="Select Region"
                    options={Region_List}
                    className={"w-100"}
                    placeholder={"Select Region"}
                    isDisabled={params?.id}
                    onChange={(item: TerritoryListProps) => {
                        setStoreDetails({
                            ...storeDetails,
                            region: item,
                            state: [],
                            city: "",
                            store_address: "",
                            pin_code: "",
                            store_contact_number: "",
                            manager_mobile: "",
                            owner_mobile: "",
                            ar_store_name:'',
                            ar_store_address:""
                        });
                        handleChangeRegion(item?.stateID);
                    }}
                    value={storeDetails.region}
                />
                {errors.region && !storeDetails.region && (
                    <span className="error-text">{errors.region}</span>
                )}
            </div>
            <div className="col-4 mt-25">
                <Input
                    type="text"
                    className="form-control"
                    placeholder="Enter Store Name"
                    onChange={(e: any) =>
                        setStoreDetails({
                            ...storeDetails,
                            store_name: e.target.value,
                        })
                    }
                    value={storeDetails?.store_name}
                    label="Store Name"
                />
                {errors.store_name && !storeDetails.store_name && (
                    <span className="error-text">{errors.store_name}</span>
                )}
            </div>
            {(storeDetails?.region?.value === constant?.STORE_REGION.KUWAIT) && <div className="col-4 mt-25">
                <Input
                    type="text"
                    className="form-control"
                    placeholder="Enter Arabic Store Name"
                    onChange={(e: any) =>
                        setStoreDetails({
                            ...storeDetails,
                            ar_store_name: e.target.value,
                        })
                    }
                    value={storeDetails?.ar_store_name}
                    label="Arabic Store Name"
                />
                {errors.ar_store_name && !storeDetails.ar_store_name && (
                    <span className="error-text">{errors.ar_store_name}</span>
                )}
            </div>}


            <div className="col-4 mt-25">
                <IntlPhoneField
                    placeholder="Enter Contact Number"
                    defaultCountryCode={
                        storeDetails?.region?.value === constant?.STORE_REGION.INDIA
                            ? constant?.COUNTRY_CODES[0].code
                            : constant?.COUNTRY_CODES[1].code
                    }
                    onChange={(e: any) => {
                        setStoreDetails({
                            ...storeDetails,
                            store_contact_number: e?.mobile,
                        });
                    }}
                    value={storeDetails.store_contact_number}
                    label="Store Contact Number"
                    disabled={!storeDetails.region}
                    disableDialCode={true}
                />
                {errors.store_contact_number &&
                    !storeDetails.store_contact_number && (
                        <span className="error-text">{errors.store_contact_number}</span>
                    )}
            </div>

            <div className="col-4 mt-25">
                <Select
                    label="State / Governorate"
                    options={territoryList}
                    className={"w-100"}
                    placeholder={"Select State"}
                    onChange={(item: any) => {
                        handleStateGovernorateChange(item);
                    }}
                    value={storeDetails.state}
                />
                {errors.state && !storeDetails.state && (
                    <span className="error-text">{errors.state}</span>
                )}
            </div>
            <div className="col-4 mt-25">
                <Select
                    label="City"
                    options={cities}
                    className={"w-100"}
                    placeholder={"Select City"}
                    disabled={!cities}
                    onChange={(item: any) =>
                        setStoreDetails({ ...storeDetails, city: item })
                    }
                    value={storeDetails.city}
                />
                {errors.city && !storeDetails.city && (
                    <span className="error-text">{errors.city}</span>
                )}
            </div>
            <div className="col-4 mt-25">
                <Input
                    type="number"
                    className="form-control"
                    placeholder="Enter Pin Code"
                    onChange={(e: any) =>
                        setStoreDetails({
                            ...storeDetails,
                            pin_code: e.target.value,
                        })
                    }
                    value={storeDetails.pin_code}
                    label="Pin Code"
                />
                {errors.pin_code && !storeDetails.pin_code && (
                    <span className="error-text">{errors.pin_code}</span>
                )}
            </div>
            <div className="col-4 mt-25">
                <Input
                    type="text"
                    className="form-control"
                    placeholder="Enter Store Address"
                    onChange={(e: any) =>
                        setStoreDetails({
                            ...storeDetails,
                            store_address: e.target.value,
                        })
                    }
                    value={storeDetails.store_address}
                    label="Store Address"
                />
                {errors.store_address && !storeDetails.store_address && (
                    <span className="error-text">{errors.store_address}</span>
                )}
            </div>
            {(storeDetails?.region?.value === constant?.STORE_REGION.KUWAIT) && <div className="col-4 mt-25">
                <Input
                    type="text"
                    className="form-control"
                    placeholder="Enter Arabic Store Address"
                    onChange={(e: any) =>
                        setStoreDetails({
                            ...storeDetails,
                            ar_store_address: e.target.value,
                        })
                    }
                    value={storeDetails.ar_store_address}
                    label="Arabic Store Address"
                />
                {errors.ar_store_address && !storeDetails.ar_store_address && (
                    <span className="error-text">{errors.ar_store_address}</span>
                )}
            </div>}

            <div className="col-4 mt-25">
                <div className="position-relative">
                    <label className="inputs-label mb-2 fs-16 fw-600  secondary-color">
                        Store Name and Location
                    </label>
                    <input
                        type="text"
                        className={"inputs form-control w-100"}
                        placeholder={"Enter Store Name and Location"}
                        value={storeDetails.store_location}
                        onChange={(e: any) => _handleSearchStoreLocation(e.target.value)}
                    // disabled={params?.id ? true : false}
                    />
                </div>
                {(errors.store_location || !storeDetails.store_location) && (
                    <span className="error-text">{errors.store_location}</span>
                )}
            </div>

            <div className="col-4 mt-25">
                <div className="position-relative">
                    <label className="inputs-label mb-2 fs-16 fw-600  secondary-color">
                        Store Code
                    </label>
                    <input
                        type="text"
                        className={"inputs form-control w-100"}
                        placeholder={"Enter Store Code"}
                        value={storeDetails.store_code}
                        onChange={(e: any) =>
                            setStoreDetails({
                                ...storeDetails,
                                store_code: e.target.value,
                            })
                        }
                    disabled={params?.id ? true : false}
                    />
                </div>
                {(errors.store_code || !storeDetails.store_code) && (
                    <span className="error-text">{errors.store_code}</span>
                )}
            </div>
            <div className="col-4 mt-25">
                <div className="position-relative">
                    <DatePicker
                        label={"At your Service Since"}
                        placeholder={"Select"}
                        selectedYear={Number(storeDetails?.at_your_service_since)}
                        setSelectedYear={(value: number) =>
                            setStoreDetails({
                                ...storeDetails,
                                at_your_service_since: value,
                            })
                        }
                    />
                </div>
                {(errors.at_your_service_since ||
                    !storeDetails.at_your_service_since) && (
                        <span className="error-text">{errors.at_your_service_since}</span>
                    )}
            </div>
            <div className="col-4 mt-25">
                <div className="position-relative">
                    <label className="inputs-label mb-2 fs-16 fw-600  secondary-color">
                        Store Google Rating
                    </label>
                    <input
                        type="number"
                        className={"inputs form-control w-100"}
                        placeholder={"Enter Store Google Rating"}
                        value={storeDetails.google_rating}
                        onChange={(e: any) =>
                            e.target.value <= 5 &&
                            setStoreDetails({
                                ...storeDetails,
                                google_rating: e.target.value,
                            })
                        }
                    // disabled={params?.id ? true : false}
                    />
                </div>
                {(errors.google_rating || !storeDetails.google_rating) && (
                    <span className="error-text">{errors.google_rating}</span>
                )}
            </div>
            <div className="col-4 mt-25">
                <div className="position-relative">
                    <label className="inputs-label mb-2 fs-16 fw-600  secondary-color">
                        Online Store Commission (%)
                    </label>
                    <input
                        type="text"
                        className={"inputs form-control w-100"}
                        placeholder={"Enter Online Store Commission (%)"}
                        value={storeDetails.online_commission_percent}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                            isValidNumberInput(e.target.value) &&
                            setStoreDetails({
                                ...storeDetails,
                                online_commission_percent: e.target.value
                                    ? Number(e.target.value)
                                    : "",
                            })
                        }
                    />
                </div>
                {(errors.online_commission_percent ||
                    !storeDetails.online_commission_percent) && (
                        <span className="error-text">
                            {errors.online_commission_percent}
                        </span>
                    )}
            </div>
            <div className="col-4 mt-25">
                <div className="position-relative">
                    <label className="inputs-label mb-2 fs-16 fw-600  secondary-color">
                        Number of subadmin
                    </label>
                    <input
                        type="text"
                        className={"inputs form-control w-100"}
                        placeholder={"Enter Number of subadmin"}
                        value={storeDetails.number_of_subadmins}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                            isValidNumberInput(e.target.value, 1000) &&
                            setStoreDetails({
                                ...storeDetails,
                                number_of_subadmins: e.target.value
                                    ? Number(e.target.value)
                                    : "",
                            })
                        }
                    />
                </div>
                {(errors.number_of_subadmins ||
                    !storeDetails.number_of_subadmins) && (
                        <span className="error-text">{errors.number_of_subadmins}</span>
                    )}
            </div>
            <div className="col-4 mt-25">
                <div className="position-relative">
                    <label className="inputs-label mb-2 fs-16 fw-600  secondary-color">
                        Number of staff
                    </label>
                    <input
                        type="text"
                        className={"inputs form-control w-100"}
                        placeholder={"Enter Number of staff"}
                        value={storeDetails.number_of_staff}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                            isValidNumberInput(e.target.value, 1000) &&
                            setStoreDetails({
                                ...storeDetails,
                                number_of_staff: e.target.value ? Number(e.target.value) : "",
                            })
                        }
                    />
                </div>
                {(errors.number_of_staff || !storeDetails.number_of_staff) && (
                    <span className="error-text">{errors.number_of_staff}</span>
                )}
            </div>
        </div>
    );
};
